/**
 * @fileOverview Find all images and create click event
 * @name FullScreenImage.js
 * @author Christian Parker <chris@talloaks.io>
 * @license no license
 */
export default {
  inheritAttrs: false,
  mounted() {
    const imgs = this.$el.querySelectorAll('img:not(.ignore)');
    const app = this;
    for(var i = 0; i<imgs.length; i++) {
      let img = imgs[i];
      let src = img.getAttribute('src');
      if(src.indexOf('#ignore')<0){
        img.addEventListener('click', function(){
          app.$router.push(`?image=${src}`);
        });
      }
    }
  },
  computed: {
   image(){
      const query = this.$route.query;
      return query.image;
    },
  },
  methods: {
   closeImage(){
      this.$router.go(-1);
    }
  }
};
